'use strict';

Object.defineProperty(exports, "__esModule", {
        value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ElementTool = require('./ElementTool');

var _ElementTool2 = _interopRequireDefault(_ElementTool);

var _ToolSeparator = require('../ToolSeparator');

var _ToolSeparator2 = _interopRequireDefault(_ToolSeparator);

var _elementRegistry = require('../../../../common/elements/elementRegistry');

var elementRegistry = _interopRequireWildcard(_elementRegistry);

var _cardConstants = require('../../../../common/cards/cardConstants');

var _imageConstants = require('../../../../common/images/imageConstants');

var _linkConstants = require('../../../../common/links/linkConstants');

var _columnConstants = require('../../../../common/columns/columnConstants');

var _boardConstants = require('../../../../common/boards/boardConstants');

var _lineConstants = require('../../../../common/lines/lineConstants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Constants
var ElementToolRenderer = function ElementToolRenderer(_ref) {
        var elementTypeObject = _ref.elementTypeObject,
            currentBoardId = _ref.currentBoardId,
            gridSize = _ref.gridSize;
        return _react2.default.createElement(_ElementTool2.default, {
                key: elementTypeObject.elementType,
                name: elementTypeObject.displayName,
                elementType: elementTypeObject.elementType,
                currentBoardId: currentBoardId,
                gridSize: gridSize });
};

// Element Types


// Components
// Lib


ElementToolRenderer.propTypes = {
        currentBoardId: _propTypes2.default.string.isRequired,
        elementTypeObject: _propTypes2.default.object.isRequired,
        gridSize: _propTypes2.default.number.isRequired
};

var ElementToolList = function ElementToolList(props) {
        var currentBoardId = props.currentBoardId,
            gridSize = props.gridSize;

        var elementTypes = elementRegistry.getElementTypeObjects();

        return _react2.default.createElement(
                'div',
                { className: 'ToolList ElementToolList' },
                _react2.default.createElement(ElementToolRenderer, { elementTypeObject: elementTypes[_cardConstants.CARD_TYPE], currentBoardId: currentBoardId,
                        gridSize: gridSize }),
                _react2.default.createElement(ElementToolRenderer, { elementTypeObject: elementTypes[_imageConstants.IMAGE_TYPE], currentBoardId: currentBoardId,
                        gridSize: gridSize }),
                _react2.default.createElement(ElementToolRenderer, { elementTypeObject: elementTypes[_linkConstants.LINK_TYPE], currentBoardId: currentBoardId,
                        gridSize: gridSize }),
                _react2.default.createElement(_ToolSeparator2.default, null),
                _react2.default.createElement(ElementToolRenderer, { elementTypeObject: elementTypes[_columnConstants.COLUMN_TYPE], currentBoardId: currentBoardId,
                        gridSize: gridSize }),
                _react2.default.createElement(ElementToolRenderer, { elementTypeObject: elementTypes[_boardConstants.BOARD_TYPE], currentBoardId: currentBoardId,
                        gridSize: gridSize }),
                _react2.default.createElement(_ToolSeparator2.default, null),
                _react2.default.createElement(ElementToolRenderer, { elementTypeObject: elementTypes[_lineConstants.LINE_TYPE], currentBoardId: currentBoardId,
                        gridSize: gridSize })
        );
};

ElementToolList.propTypes = {
        currentBoardId: _propTypes2.default.string.isRequired,
        gridSize: _propTypes2.default.number.isRequired
};

exports.default = ElementToolList;


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/toolbar/elementTools/ElementToolList.js
// module id = 2220
// module chunks = 0